<template>
    <div class="content-carousel-item" v-if="active" :tabindex="active ? '0' : '-1'">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "CarouselItem",
        data() {
            return {
                active: false
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .content-carousel-item
        flex 1
        padding 20px 0

</style>